import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getScopeName, getScopeType, getViewName } from '../../utils/nameFormat';
const productScope = getScopeName({ entityName: 'Product' });
const settingsScope = getScopeName({ entityName: 'Settings' });
export const createScopeStmtInstruction = `
#### Create Entity scope

Scope defines a view of an entity in the application. It can be used to define a list of entities, or a form for creating or editing an entity.

- Syntax: \`create scope <scope_name> as <scope_type> in <view_name> for <entity_name> where <filter_query>;\`
- Example: \`create scope ${productScope} as dataGrid in ${getViewName({ entityName: 'Product', viewType: 'dataGrid' })} for Product;\`
- Example: \`create scope ${productScope} as create in ${getViewName({ entityName: 'Product', viewType: 'create' })} for Product;\`
- Example: \`create scope ${productScope} as edit in ${getViewName({ entityName: 'Product', viewType: 'edit' })} for Product;\`
- Example: \`create scope ${settingsScope} as unique in ${getViewName({ entityName: 'Settings', viewType: 'unique' })} for Settings;\`
- Example: \`create scope ${productScope} as dataGrid in ${getViewName({ entityName: 'Product', viewType: 'dataGrid' })} for Product where status = 'sold';\`
`;
export const stmtCreateScope = ({ scopeName, scopeType, viewName, entityName, filterQuery }) => {
    if (!filterQuery) {
        return `create scope ${scopeName} as ${scopeType} in ${viewName} for ${entityName};`;
    }
    return `create scope ${scopeName} as ${scopeType} in ${viewName} for ${entityName} where ${filterQuery};`;
};
export const createScopeHandler = createStructureStatementHandler({
    type: 'create scope',
    parse: line => {
        const match = /^(create|add) scope (?<scopeName>\w+) as (?<scopeType>\w+) in (?<viewName>\w+) for (?<entityName>\w+)( where (?<filterQuery>[\w\s=><!@#$%^&*()\-+[\]{}:'",./?|~]+))?/.exec(line);
        return match?.groups
            ? {
                type: 'create scope',
                scopeName: match.groups.scopeName,
                scopeType: getScopeType(match.groups.scopeType),
                viewName: match.groups.viewName,
                entityName: match.groups.entityName,
                filterQuery: match.groups.filterQuery,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.addScope({
        scopeName: stmt.scopeName,
        scopeType: stmt.scopeType,
        viewName: stmt.viewName,
        entityName: stmt.entityName,
        filterQuery: stmt.filterQuery,
    })),
});
//# sourceMappingURL=CreateScopeStmt.js.map